import React from 'react';
import Header from '../../../Components/UserComponents/Header/Header';
import Body from '../../../Components/UserComponents/Body/Body';
import Footer from '../../../Components/UserComponents/Footer/Footer';


const Home = () => {
  return (
    <div>
      <Header />
      <Body />
      <Footer />

    </div >
  );
};

export default Home;